import { jsx as l, jsxs as x } from "react/jsx-runtime";
import { b as c, T } from "./TablePaginationActions-EC4ynZRa.js";
import { styled as M, Alert as v, Fade as b, AlertTitle as I } from "@mui/material";
import { forwardRef as $, useState as k } from "react";
const S = M(v, {
  shouldForwardProp: (r) => ![
    "isNeutral",
    "content",
    "hasCloseButton",
    "hasAction",
    "hasTitle",
    "isSticky"
  ].includes(r)
})(
  ({
    isNeutral: r,
    content: n,
    hasCloseButton: a,
    hasAction: o,
    hasTitle: e,
    isSticky: t,
    theme: i
  }) => ({
    columnGap: i.spacing(1),
    minHeight: i.spacing(6),
    ...o && {
      display: "grid",
      gridTemplateAreas: n === "inline" || a ? '"icon message actions"' : `
    "icon message"
    "icon actions"
    `,
      gridTemplateColumns: a ? `${c} 1fr ${i.spacing(3)}` : `${c}`
    },
    ...r && {
      backgroundColor: i.palette.default.background,
      color: i.palette.text.primary
    },
    ...t && {
      borderRadius: 0
    },
    ".MuiAlert-message": {
      flex: 1,
      paddingTop: e ? i.spacing(0.25) : i.spacing(0.5),
      "& a": {
        color: i.palette.primary.main,
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline"
        }
      },
      ...o && {
        gridArea: "message"
      },
      ...r && {
        "& :not(.MuiAlertTitle-root)": {
          color: i.palette.text.secondary
        },
        a: {
          color: `${i.palette.primary.main} !important`
        }
      }
    },
    ".MuiAlert-icon": {
      height: e ? i.spacing(2.5) : i.spacing(3),
      marginRight: 0,
      ...o && {
        gridArea: "icon"
      },
      ...r && {
        color: i.palette.text.primary
      }
    },
    ".MuiAlert-action": {
      alignItems: n === "inline" && !a ? "center" : "flex-start",
      margin: n === "block" && !a ? i.spacing(1.5, 0, 0.5) : 0,
      marginLeft: n === "inline" || a ? "auto" : 0,
      padding: 0,
      ...o && {
        gridArea: "actions"
      },
      ".MuiIconButton-root svg path": {
        fill: a ? i.palette.text.secondary : void 0
      }
    }
  })
);
function D({
  title: r,
  action: n,
  severity: a = "neutral",
  content: o = "inline",
  variant: e = "standard",
  children: t,
  onClose: i,
  open: s,
  isSticky: d,
  ...g
}, u) {
  const [f, m] = k(s ?? !0), A = i ? (y) => {
    i(y), m(!1);
  } : void 0, p = a === "neutral";
  return /* @__PURE__ */ l(b, { in: s ?? f, appear: !1, children: /* @__PURE__ */ x(
    S,
    {
      ref: u,
      severity: p ? "info" : a,
      isNeutral: p,
      content: o,
      action: n,
      onClose: A,
      hasCloseButton: !!i,
      hasAction: !!n,
      hasTitle: !!r,
      isSticky: d,
      variant: e,
      ...g,
      children: [
        r && /* @__PURE__ */ l(I, { children: r }),
        /* @__PURE__ */ l(T, { variant: "caption", color: "inherit", component: "div", children: t })
      ]
    }
  ) });
}
const E = $(D);
export {
  E as A
};
